<template>
<div class="chapter">
<div class="inner_page">
<section class="dedication" epub:type="dedication">
<p class="no_header firstInSection"><em>For all their steadfast love and support, my thoughts go out to my two lovely sisters, Winifred and Anita.</em></p>
<p><em>Life hasn’t been easy for them, but they can always find a smile, bless their hearts.</em></p>
<p><em>Not forgetting my seven brothers, Sonny, Joseph, Bernard, Richard, Billy, Harry and Alec.</em></p>
<p><em>They could never be described as angels, but our late lovely Mam would have been as proud of them all as I am. (Keep the meat an’ tater pies hot, lads!)</em></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?76299e30